<template>
    <v-menu 
        v-if="clipboardImage" 
        ref="menuClipboardImage" 
        v-model="menuClipboardImage"
        attach=".refMenuClipboardImage" 
        top 
        :close-on-click="false" 
        :close-on-content-click="false"
    >
        <v-card color="grey lighten-5" class="mx-auto" width="350">
            <v-img :src="clipboardImage" height="300" contain></v-img>

            <v-card-actions class="justify-end">
                <v-btn 
                    small 
                    color="red" 
                    text @click="$emit('clear-clipboard-image')"
                    :loading="isSendingClipboardImage"
                >
                    <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-menu>
</template>

<script>
export default {
    name: 'ClipboardImageMenu',
    props: {
        clipboardImage: {
            type: String,
            required: false,
        },
        isSendingClipboardImage: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            menuClipboardImage: true,
        };
    },
};
</script>